import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        selectorContent: {
            w: '100%',
            maxW: remCalc(688),
            px: {base: remCalc(16), lg: remCalc(24)},
            py: remCalc(24),
            gap: {base: remCalc(16), lg: remCalc(24)},
            mx: remCalc(16),
        },
        selectorHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            p: `0 0 ${remCalc(16)} 0`,
            borderBottomColor: 'border.dark',
            borderBottomWidth: remCalc(1),
        },
        modalBody: {
            p: 0,
        },
        selectorFooter: {
            p: 0,
        },
        closeButton: {
            w: '100%',
        },
    },
    variants: {
        hiddenCloseButton: {
            closeButtonContainer: {
                display: 'flex',
                justifyContent: 'flex-end',
                py: remCalc(16),
                pr: remCalc(24),
                position: 'relative',
                top: 0,
                left: 0,
                w: '100%',
                '@media (min-width: 900px)': {
                    position: 'absolute',
                },
            },
            closeIcon: {
                w: remCalc(40),
                h: remCalc(40),
            },
            '.sc-bWJUgm.ceAPfk': {
                display: 'none',
            },
            '.sc-fscmHZ.ejnbJn': {
                h: remCalc(72),
                '@media (max-width: 899px)': {
                    display: 'none',
                },
            },
        },
    },
}
